import { useState } from 'react'
import './DropArea.css'
function DropArea({ onDrop, children }) {
  const [showDrop, setShowDrop] = useState(false)

  const style = {
    flexGrow: 1,
    background: 'lightgray',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '50px',
  }

  return (
    <section
      onDragEnter={(e) => {
        e.preventDefault()
        setShowDrop(true)
      }}
      onDragLeave={(e) => {
        e.preventDefault()
        setShowDrop(false)
      }}
      onDrop={(e) => {
        e.preventDefault()
        e.stopPropagation()
        onDrop()
        setShowDrop(false)
      }}
      onDragOver={(e) => {
        e.preventDefault()
        e.dataTransfer.dropEffect = 'move' // Safari compatibility
      }}
      className={showDrop ? 'drop_area' : 'hide_drop'}
      style={children && style}
    >
      <span className='invisible'>asd</span>
    </section>
  )
}

export default DropArea
